module.exports = __webpack_public_path__ + "img/font.40568f44.svg";